import { CommandBar, useTheme } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { layoutSlice } from "../slices";
const commandBarCallbacks = {
    items: {},
    farItems: {}
};
const onClick = (ev, callbacks, item) => {
    var _a;
    (_a = callbacks[item.key]) === null || _a === void 0 ? void 0 : _a.call(callbacks, ev);
};
const removeEvents = (callbacks, prefix, item) => {
    const key = `${prefix}/${item.key}`;
    callbacks[key] = item.onClick;
    return Object.assign(Object.assign({}, item), { key: key, onClick: undefined, subMenuProps: item.subMenuProps != undefined
            ? {
                items: item.subMenuProps.items != undefined
                    ? item.subMenuProps.items.map(x => removeEvents(callbacks, item.key, x))
                    : undefined
            }
            : undefined });
};
const restoreEvents = (callbacks, item) => {
    return Object.assign(Object.assign({}, item), { onClick: (ev) => onClick(ev, callbacks, item), subMenuProps: item.subMenuProps != undefined
            ? {
                items: item.subMenuProps.items != undefined
                    ? item.subMenuProps.items.map(x => restoreEvents(callbacks, x))
                    : undefined
            }
            : undefined });
};
export const useCommandBar = () => {
    const dispatch = useDispatch();
    return {
        setItems: (items = []) => {
            const processedItems = items.map(x => removeEvents(commandBarCallbacks.items, '', x));
            dispatch(layoutSlice.actions.setCommandBarItems(processedItems));
        },
        setFarItems: (items = []) => {
            const processedItems = items.map(x => removeEvents(commandBarCallbacks.farItems, '', x));
            dispatch(layoutSlice.actions.setCommandBarFarItems(processedItems));
        },
        clearItems: () => {
            dispatch(layoutSlice.actions.setCommandBarItems([]));
        },
        clearFarItems: () => {
            dispatch(layoutSlice.actions.setCommandBarFarItems([]));
        }
    };
};
export const ACCommandBar = () => {
    const theme = useTheme();
    const items = useSelector(x => x.layout.commandBarItems) || [];
    const farItems = useSelector(x => x.layout.commandBarFarItems) || [];
    const processedItems = items.map(item => restoreEvents(commandBarCallbacks.items, item));
    const processedFarItems = farItems.map(item => restoreEvents(commandBarCallbacks.farItems, item));
    const rootStyle = {
        display: "flex",
        flexDirection: "column",
        paddingLeft: "10px",
        paddingRight: "10px"
    };
    const commandBarItemStyle = {
        alignItems: "center",
        backdropFilter: "blur(6px)",
        backgroundColor: theme.palette.white,
        borderBottomLeftRadius: "6px",
        borderBottomRightRadius: "6px",
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        boxShadow: "rgba(47, 43, 61, 0.14) 0px 2px 6px 0px",
        boxSizing: "border-box",
        color: "rgba(47, 43, 61, 0.78)",
        display: "flex",
        justifyContent: "space-between",
        lineHeight: "22px",
        minHeight: "44px",
        height: "44px",
        paddingBottom: "0px",
        paddingLeft: "10px",
        paddingRight: "5px",
        paddingTop: "0px",
        position: "relative",
        userSelect: "none",
        width: "100%"
    };
    return React.createElement("div", { "data-role": "command-bar", style: rootStyle },
        React.createElement(CommandBar, { style: commandBarItemStyle, items: processedItems, farItems: processedFarItems }));
};
